<template>
  <BaseDialogForm
    :nonFieldErrors="formErrors.non_field_errors"
    :title="`Change ${tripModule.trip} Assets`"
    v-model="showTripAssetChangeForm"
    width="60%"
  >
    <template #content>
      <v-form
        v-model="isValid"
        ref="assetChangeForm"
        @submit.prevent="updateTripAsset"
      >
        <v-row class="ma-0">
          <v-col cols="12" md="6">
            <v-chip class="ml-2" color="accent" v-if="tripInfo['driver_info']">
              <v-icon class="mr-2">mdi-account-tie-hat</v-icon>
              {{ tripInfo["driver_info"]["full_name"] }}
            </v-chip>
          </v-col>
          <v-col cols="12" md="6">
            <v-chip class="ml-2" color="accent" v-if="tripInfo['vehicle_info']">
              <v-icon class="mr-2">mdi-truck</v-icon>
              {{ tripInfo["vehicle_info"]["vehicle_number"] }}
            </v-chip>
          </v-col>
          <v-col cols="12" md="6">
            <SelectField
              id="driver"
              :itemsList="driverList"
              :label="`Select ${fleetModule.driver}`"
              name="driver"
              itemText="full_name"
              itemValue="id"
              v-model="selectedDriver"
              :errorMessages="formErrors.driver"
              @change="delete formErrors.driver"
            />
          </v-col>
          <v-col cols="12" md="6">
            <SelectField
              id="vehicle"
              :itemsList="vehicleList"
              v-model="selectedVehicle"
              name="vehicle"
              itemText="vehicle_number"
              itemValue="id"
              :label="`Select ${fleetModule.vehicle}`"
              :errorMessages="formErrors.vehicle"
              @change="delete formErrors.vehicle"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #actions>
      <v-btn
        id="assetChangeSubmit"
        depressed
        @click="updateTripAsset"
        color="primary"
        :disabled="!isValid || (!selectedDriver && !selectedVehicle)"
        >Submit</v-btn
      >
    </template>
  </BaseDialogForm>
</template>

<script>
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";
import { bus } from "@/main";
import { fleetModule, tripModule } from "@/utils/moduleMapping";
export default {
  components: { BaseDialogForm },
  emits: ["refreshDetails"],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tripObj: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getAssetInfo();
        this.selectedDriver = this.tripObj.driver;
        this.selectedVehicle = this.tripObj.vehicle;
      }
    },
  },
  data() {
    return {
      tripModule,
      fleetModule,
      isValid: true,
      formDetails: {},
      formErrors: {},

      driverList: [],
      vehicleList: [],

      selectedDriver: null,
      selectedVehicle: null,

      tripInfo: {},
    };
  },
  computed: {
    showTripAssetChangeForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    constructPayload() {
      this.formDetails.vehicle =
        this.tripObj.vehicle != this.selectedVehicle
          ? this.selectedVehicle
          : null;
      this.formDetails.driver =
        this.tripObj.driver != this.selectedDriver ? this.selectedDriver : null;
    },
    updateTripAsset() {
      if (!this.$refs.assetChangeForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      bus.$emit("showLoader", true);
      this.constructPayload();
      this.$api.trip
        .updateTripAsset(this.tripObj.id, this.formDetails)
        .then(() => {
          this.showTripAssetChangeForm = false;
          this.$emit("refreshDetails");
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          if (err.data) {
            this.formErrors = err.data;
          }
          bus.$emit("showLoader", false);
        });
    },
    getAssetInfo() {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripAssetInfo(this.tripObj.id)
        .then((res) => {
          this.tripInfo = res.data;
          this.getVehicleSelectList({
            // idle_vehicles: res.data.trip_date,
            is_active: true,
          });
          this.getDriverSelectList({
            // idle_drivers: res.data.trip_date,
            is_active: true,
          });
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getDriverSelectList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      bus.$emit("showLoader", true);
      this.$api.driver
        .getDriverSelectList(params)
        .then((res) => {
          this.driverList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getVehicleSelectList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      bus.$emit("showLoader", true);
      this.$api.vehicle
        .getVehicleSelectList(params)
        .then((res) => {
          this.vehicleList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style></style>
